import { flex } from "@styled-system/patterns";

export const conditionsPreviewItemClass = flex({
	justifyContent: "space-between",
	alignItems: "center",
});
